import React from 'react'
// import { includes } from 'lodash'

import { Search as SearchAPI } from '@monorepo/deprecated/hooks'
import { BrandItem } from './BrandItem'
import { BrandType } from '@monorepo/interfaces'

type BrandsListPropsType = {
  items: any[]
}

export const BrandsList: React.FC<BrandsListPropsType> = ({ items }) => {
  const { brands } = SearchAPI.useResult()
  const {
    excludeBrands,
    changeExcludeBrandsHandler,
  } = SearchAPI.useResultControl()

  const handleChange = React.useCallback(
    (brand: BrandType, event: React.ChangeEvent<HTMLInputElement>) => {
      const selected = event.target.checked
      changeExcludeBrandsHandler(brand, !selected)
    },
    [changeExcludeBrandsHandler]
  )

  return (
    <div className="filter-list">
      <div className="filter-list__list">
        {brands.map((item, idx) => (
          <BrandItem
            key={idx}
            item={item}
            name={item.name}
            disabled={
              !excludeBrands.includes(item) &&
              brands.length - excludeBrands.length < 2
            }
            checked={!excludeBrands.includes(item)}
            onChange={handleChange.bind(null, item)}
          />
        ))}
      </div>
    </div>
  )
}
